var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"La0",style:({
  gridTemplateColumns: _vm.ratio
})},[_c('div',{staticClass:"La0_left"},[_vm._t("left")],2),_c('div',{staticClass:"La0_right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }